import React, {useEffect, useLayoutEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import "firebase/auth";
import { toast } from "react-toastify"
import { withRouter } from "react-router-dom";
import AsideContacts from '../../components/AsideContacts';
import AsideNewFeed from '../../components/AsideNewFeed';
import {auth, getAuthenticationStatus} from "../../utils/auth-service";
// Redux
import profileActions from "../../redux/profile/actions";
import {database} from '../../firebase';

function Settings2(){
    const dispatch = useDispatch();

    const { currentUser = [] } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
    }));



    async function logout() {
        try {
            dispatch({
              type: profileActions.DEAUTH_USER,
              payload: {
                currentUser,
              },
            });
        } catch (error) {
            console.log(error);
        }
    }

    document.title = "Settings";
    return (
      <>
        {/* Left Aside */}
        <AsideNewFeed></AsideNewFeed>

        <section className="main-content">
          <div className="middle-box">
            <div className="row">
              <div className="col-sm-12 mb-3">
                <div className="card border-0 rounded-xl shadow-xs">
                  <div className="card-body p-4 p-md-5">
                    <h3 className="fw-bold mb-4">Settings</h3>

                    <h5 className="fw-bold fs-12 text-lightgrey mb-3">
                      General
                    </h5>
                    <ul className="aside-iconlist setting-menulist">
                      <li>
                        <Link to="/edit-profile">
                          <span className="bg-blue-gradient me-sm-3">
                            <svg className="icon">
                              <use href="#icon_user"></use>
                            </svg>
                          </span>
                          Edit Profile
                        </Link>
                      </li>
                      {/*<li>*/}
                      {/*    <Link to="/ResetPassword">*/}
                      {/*    <span className="bg-violet-gradient me-sm-3">*/}
                      {/*        <svg className="icon"><use href="#icon_password"></use></svg>*/}
                      {/*    </span>*/}
                      {/*        Password*/}
                      {/*    </Link>*/}
                      {/*</li>*/}
                    </ul>
                    <h5 className="fw-bold fs-12 text-lightgrey mt-4 mb-3">
                      Other
                    </h5>
                    <ul className="aside-iconlist setting-menulist">
                      <li>
                        <Link to="/Notifications">
                          <span className="bg-red2-gradient me-sm-3">
                            <svg className="icon">
                              <use href="#icon_notification"></use>
                            </svg>
                          </span>
                          Notification
                        </Link>
                      </li>
                      <li>
                        {/*<button> onClick={logout()}</button>*/}
                        <Link to="/login" onClick={() => logout()}>
                          <span className="bg-green-gradient me-sm-3">
                            <svg className="icon">
                              <use href="#icon_logout">Settings2</use>
                            </svg>
                          </span>
                          Logout
                        </Link>
                      </li>
                        <h5 className="fw-bold fs-12 text-lightgrey mt-4 mb-3">
                            Build Info
                        </h5>
                        <li>
                            <a href='https://trello.com/c/YR20q7vk/1-how-does-this-board-work'>
                          <span className="bg-theme-gradient me-sm-3">
                            <svg className="icon">
                              <use href="#icon_alert"></use>
                            </svg>
                          </span>
                                β 0.0.5
                            </a>
                        </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Right Aside */}
        <AsideContacts></AsideContacts>
      </>
    );
}

export default withRouter(Settings2);